import { render, staticRenderFns } from "./CenterLayoutForm.vue?vue&type=template&id=0c045743&scoped=true"
import script from "./CenterLayoutForm.vue?vue&type=script&lang=js"
export * from "./CenterLayoutForm.vue?vue&type=script&lang=js"
import style0 from "./CenterLayoutForm.vue?vue&type=style&index=0&id=0c045743&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c045743",
  null
  
)

export default component.exports